import { gql } from '@apollo/client';
import { User, PageInfo } from './types';

/**
 * GraphQL query to fetch all users
 * Supports pagination and filtering by roles
 */
export const GET_USERS = gql`
  query GetUsers(
    $first: Int
    $after: String
    $last: Int
    $before: String
    $where: RootQueryToUserConnectionWhereArgs
  ) {
    users(
      first: $first
      after: $after
      last: $last
      before: $before
      where: $where
    ) {
      nodes {
        id
        databaseId
        name
        email
        username
        registeredDate
        roles {
          nodes {
            name
          }
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;

export interface GetUsersData {
  users: {
    nodes: User[];
    pageInfo: PageInfo;
  };
}

export interface GetUsersVariables {
  first?: number;
  after?: string;
  last?: number;
  before?: string;
  where?: {
    roleIn?: string[];
    search?: string;
  };
}
